import React, { useEffect, useState, useRef } from "react";
import SearchComponent from "../../Search/SearchComponent/SearchComponent";
import "./stylessh.css";
//import { licitaciones2021 } from "../../../json/LicitacionesEstatales/licitaciones2021";
const res = await fetch('/JSON/LicitacionesEstatales/licitaciones2021.json')
const licitaciones2021 = await res.json()


const Licitaciones2021 = () => {
  const [search, setSearch] = useState("");
  const searchInput = useRef();
  var licitaciones = "";
  licitaciones = JSON.stringify(licitaciones2021);
  licitaciones = JSON.parse(licitaciones);

  const searchTram = () => {
    licitaciones = JSON.stringify(licitaciones2021);
    licitaciones = JSON.parse(licitaciones);
    setSearch(searchInput.current.value);
  };

  let filterLicitaciones = licitaciones.filter((licitacion) => {
    let licitaciones = licitacion.licitaciones_array;
    if (!licitacion.nombre_licitacion.toLowerCase().includes(search.toLowerCase())) {
      licitacion.licitaciones_array = licitaciones.filter((licitacionDet) => {
        return licitacionDet.licitacion_item_nombre
          .toLowerCase()
          .includes(search.toLowerCase());
      });
    }
    if (
      licitacion.licitaciones_array.length > 0 ||
      licitacion.nombre_licitacion.toLowerCase().includes(search.toLowerCase())
    ) {
      return licitacion;
    }
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container transparencia-container">
      <div className="row">
        <div className="col-12">
          <div className="transparencia_title">
            <h1>Licitaciones 2021</h1>
          </div>
        </div>
      </div>
      <SearchComponent
        searchInput={searchInput}
        search={search}
        searchTram={searchTram}
      />
       <div className="row">
        {filterLicitaciones.map((item, index) => (
          <div key={index} className="col-12 item licitacion">
            <h1 className="numero-licitacion">{item.id_licitacion} <span className="tipo-licitacion">{item.tipo_licictacion}</span></h1>
            <div className="item cuerpo-licitacion">
            <p className="descripcion-licitacion">{item.nombre_licitacion} </p>
                {" "}
                {item.licitaciones_array.map((lici, i) => (
                     <div>
                    {" "}
                    <a className="archivo-pdf"
                      target="{_blank}"
                      key={i}
                      href={lici.licitacion_item_url}
                    >
                      {lici.licitacion_item_nombre}
                    </a>{" "}
                  </div>
                ))}{" "}
          </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Licitaciones2021;
